import React from 'react'
import Icon from '../components/icon'
import icons from '_/config/icons.json'
import * as Bs from 'react-bootstrap'
import moment from 'moment'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'

/**
 * An event timeline widget
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class EventTimeline extends React.Component {
  static propTypes  = {
    events: React.PropTypes.object.isRequired
  }

  render() {
    return (
      <Bs.Table className="redi-component-event-timeline" condensed>
        {this.props.events.map((event, key) => (
          <tr key={key}>
            <td>
              <span dangerouslySetInnerHTML={{
                __html: event.get('formattedMessage')
              }}/>
              <br/>
              <i className="text-muted">
                {moment(event.get('createdAt')).fromNow()}
              </i>
            </td>
            <td width="100" style={{ color: 'lightgray' }} className="text-center">
              <Icon name={icons[event.get('icon')]} size="2x"/>
            </td>
          </tr>
        ))}
      </Bs.Table>
    )
  }
}

export default EventTimeline



// WEBPACK FOOTER //
// ./modules/shared/components/eventTimeline.js